import { api } from '@bilibili-maoer/web-utils';
import { getFetch } from '../../../utils/fetcher.js';
import '@babel/runtime-corejs3/core-js/instance/concat';

var logout = function logout() {
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/account/logout")
  }).then(function () {
    window.location.reload();
  }).catch(function () {});
};

export { logout };
